import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { Form, Segment } from "semantic-ui-react";
import ErrorCodeEditVM from "./ErrorCodeEditVM"




interface Props {
    viewModel: ErrorCodeEditVM;
}

const ErrorCodeEdit: FC<Props> = ({ viewModel }) => {
    return (
        <Segment>
            <Form>
                <Form.Input
                    label='ID'
                    type='text'
                    value={viewModel.id}
                    onChange={e => viewModel.setId(e.target.value)} />
                <Form.Input
                    label='Название'
                    type='text'
                    value={viewModel.name}
                    onChange={e => viewModel.setName(e.target.value)} />
                <Form.Input
                    label='Описание'
                    type='text'
                    value={viewModel.description}
                    onChange={e => viewModel.setDescription(e.target.value)} />

                <Form.Group inline>
                    <Form.Button
                        color='black'
                        content='Отмена'
                        onClick={() => viewModel.onClose()}
                    />
                    <Form.Button positive
                        icon="checkmark"
                        labelPosition="right"
                        content="Сохранить"
                        onClick={() => viewModel.saveCode()}
                    />
                </Form.Group>
            </Form>

        </Segment>
    )
}

export default observer(ErrorCodeEdit);